<template>
  <div class="content">
    <div class="background-image-search" style="background-image: url(img/temp/blurred-dark.jpg"></div>
    <!-- /.background-image-search -->

    <base-header class="pb-6" type="none">
      <b-row align-v="center" class="py-4">
        <b-col xs="12" lg="6">
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
        <b-col xs="12" lg="6" align="right">
          <router-link to="/ingredient/add-ingredient"><base-button type="secondary" size="sm" class="btn-secondary--alt">Add Product</base-button></router-link>
          <router-link to="/recipe/add-recipe"><base-button type="secondary" size="sm" class="btn-secondary--alt">Add Recipe</base-button></router-link>
        </b-col>
      </b-row>
    </base-header>
    <b-container class="container--md mt--6">
      <div>
        <card class="no-border-card mt-2 card-results" header-classes="pb-1" body-classes="px-0 pt-0 pb-0" footer-classes="pb-2">
          <template slot="header">
            <b-row align-h="end">
              <b-col cols="4">
                <form @submit.prevent="">
                  <base-input type="textarea"
                              v-model="sq"
                              placeholder="Search Products">
                  </base-input>
                </form>
              </b-col>
              <b-col sm="12" md="6" lg="4" class="d-flex align-items-left flex-wrap pt-2">
                <p class="mb-0 mr-2 text-sm">Show</p>

                <el-select class="select-primary pagination-select" v-model="perPage" placeholder="Per page">
                  <el-option class="select-primary" v-for="item in perPageOptions" :key="item" :label="item" :value="item">
                  </el-option>
                </el-select>

                <p class="mb-0 ml-2 text-sm">ingredients</p>

              </b-col>

              <b-col sm="12" md="6" lg="4" class="text-right">
                <!-- Toggle usda/database ingredient list -->
              </b-col>
            </b-row>
          </template>
          <div style="position: relative">

            <div v-show="this.loading" class="loading">
                  <loading-panel></loading-panel>
            </div>
            <el-table :data="ingredients"
              row-key="id"
              header-row-class-name="thead-light"
              class="table-results"
              v-if="view === 'table'">

              <el-table-column label="Result title" min-width="531px" prop="name" sortable>
                
                <template v-slot="{ row }">
                  <b-media no-body class="align-items-center">
                    <a :href="row.id" @click="loadIngredientPage($event)" class="avatar mr-3 table__avatar" :class="(!row.image)?'avatar--grey':' rounded-circle'">
                      <!-- <b-img alt="Image placeholder" :src="row.image" v-if="row.img"></b-img> -->
                      <span v-if="!row.image">{{ row.description ? row.description.charAt(0) : 'W' }}</span>
                    </a>
                    <b-media-body class="table__title-wrapper">
                      <a :href="row.id" @click="loadIngredientPage($event)">
                        <span class="font-weight-600 name mb-0 text-sm">{{ row.description }}</span>
                      </a>
                    </b-media-body>
                  </b-media>
                </template>
              </el-table-column>
              <!--
              <el-table-column label="Status" min-width="175px" prop="status" sortable>
                <template v-slot="{ row }">
                  <badge class="badge-dot mr-4" type="inherit" v-if="row.statusCode">
                    <i :class="`bg-${row.statusCode}`"></i>
                    <span class="status font-weight-600">{{ row.statusName && row.statusName != null ? row.statusName : 'Created' }}</span>
                  </badge>
                </template>
              </el-table-column>
              -->

              <el-table-column label="Author" min-width="176px" prop="author" sortable>
                <template v-slot="{row}">
                  <b-img :src="row.user && row.user.image ? row.user.image.absoluteUri : 'img/DefaultUser.gif'" rounded="circle" class="avatar-sm mr-2"/>
                </template>
              </el-table-column>

              <el-table-column label="Date created" min-width="201px" prop="date" sortable>
                <template v-slot="{ row }">
                  <span class="font-weight-600">{{ dateFormat(row.createdOn) }}</span>
                </template>
              </el-table-column>

              <el-table-column min-width="94px" align="last" label="Actions">
                <template v-slot="{ $index, row }" v-if="this.$store.getters.userIsAdmin">
                  <el-dropdown trigger="click" class="dropdown">
                    <span class="btn btn-sm btn-icon-only text-light mr-0">
                      <i class="fas fa-ellipsis-v mt-2"></i>
                    </span>
                    <el-dropdown-menu class="dropdown-menu dropdown-menu-arrow show" slot="dropdown">
                      <b-dropdown-item>View</b-dropdown-item>
                      <b-dropdown-item @click.native="handleEdit($index, row)">Edit</b-dropdown-item>
                      <b-dropdown-item>Share</b-dropdown-item>
                      <b-dropdown-item>Invite</b-dropdown-item>
                      <b-dropdown-item @click.native="handleDelete($index, row)">Delete</b-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div slot="footer" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
            <div class="">
              <p class="card-category">
                Showing {{ from + 1 }} to {{ to }} of {{ count }} entries
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              :current="currentPage"
              :per-page="perPage"
              :total="count"
              @change="paginationChanged($event)"
            >
            </base-pagination>
          </div>
        </card>
      </div>
    </b-container>
  </div>
</template>
<script>
import { Table, TableColumn, Select, Option, DropdownMenu, DropdownItem, Dropdown } from 'element-ui';
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import { BasePagination } from '@/components';
// import clientPaginationMixin from '@/views/Tables/PaginatedTables/clientPaginationMixin';
import swal from 'sweetalert2';
import LoadingPanel from '@/components/LoadingPanel.vue';

export default {
  // mixins: [clientPaginationMixin],
  components: {
    BasePagination,
    RouteBreadCrumb,
    LoadingPanel,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
  },
  data() {
    return {
      propsToSearch: ['name', 'description', 'brand'],
      data: null,
      itemLimit: '10',
      view: 'table',
      sq: this.$route.query.sq,
      loading: '',
      pauseSearch: false,
      perPage: 25,
      currentPage: 1,
      perPageOptions: [5, 10, 25, 50],
    };
  },
   computed: {
     ingredients() {
      return Object.values(this.$store.state.ingredients.all[1])
     },
     isLoading() {
       return this.$store.getters.ingredientsLoading
     },
     to() {
      let highBound = this.from + this.perPage;
      if (this.count < highBound) {
        highBound = this.count;
      }
      return highBound;
    },
    from() {
      return this.perPage * (this.currentPage - 1);
    },
    count() {
      return this.$store.state.ingredients.all[0];
    }
  },
  methods: {
    dateFormat(date) {
      var local = new Date(date);
      return local.toLocaleDateString("en-US")
    },
    paginationChanged(page) {
      this.currentPage = page;
      this.searchIngredients();
    },
    searchIngredients() {
      const { dispatch } = this.$store;
      dispatch("ingredients/getIngredients",{
        "query": this.sq, 
        "page": this.currentPage, 
        "pageSize": this.perPage, 
        "filter": "P"
        });
    },
    handleEdit(index, row) {
        this.$root.$router.push({
            name: 'Add Ingredient',
            params: { data: row.id }
        });
    },
    handleDelete(index, row) {
      swal.fire({
        title: 'Are you sure?',
        text: `You won't be able to revert this!`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        confirmButtonText: 'Yes, delete it!',
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.deleteRow(row);
          swal.fire({
            title: 'Deleted!',
            text: `You deleted ${row.title}`,
            type: 'success',
            confirmButtonClass: 'btn btn-success btn-fill',
            buttonsStyling: false,
          });
        }
      });
    },
    deleteRow(row) {
      let indexToDelete = this.ingredients.findIndex((tableRow) => tableRow.id === row.id);
      if (indexToDelete >= 0) {
        this.tableData.splice(indexToDelete, 1);
      }
    },
    toggleActive(event, view) {
      event.preventDefault();

      const button = event.target.closest('.btn-view');
      const card = document.querySelector('.card-results');

      button.classList.add('active')

      Array.prototype.filter.call(button.parentNode.children, function(child){
        if (child !== button) {
          child.classList.remove('active')
        }
      });

      this.view = view;

      this.view == 'grid'
        ? card.classList.add('card-results--alt')
        : card.classList.remove('card-results--alt')
    },
    loadIngredientPage(event) {
      event.preventDefault();

      let route = 'ingredient';
      const button = event.target.closest('a');

      if (button) {
        this.$router.push({
          path: route,
          query: {
            id: button.getAttribute('href')
          }
        }).catch(() => {});
      }
    }
  },
  created() {
    this.searchIngredients();
  },
  watch: {
    isLoading (newLoad, oldLoad) {
        this.loading = newLoad
    },
    perPage (val,old) {
      this.currentPage = 1;
      this.searchIngredients();
    },
    sq: function (val,old) {
      this.sq = val;
        if (!this.pauseSearch) {
          setTimeout(() => {
            this.searchIngredients();
            this.pauseSearch = false;
          }, 800); // 1 sec delay
        }
        this.pauseSearch = true;
    }
  }
};
</script>
<style>
.no-border-card .card-footer {
  border-top: 0;
}
</style>
